import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=07e3da0a&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "@/common.css?vue&type=style&index=0&id=07e3da0a&scoped=true&lang=css&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=07e3da0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e3da0a",
  null
  
)

export default component.exports